(function () {
  var SvgChartGlobal = MST;
  var SvgChartUtil = MST.SvgChartUtil;
  var SvgChartView = MST.SvgChartView;
  var SvgChartActionView = MST.SvgChartActionView;
  var SvgChartControllerView = MST.SvgChartControllerView;
  var SvgChartScrollView = MST.SvgChartScrollView;
  var SvgChartTechnical = MST.SvgChartTechnical;

  var SvgChart = function (chart) {
    this.chartDiv = chart;
    this.chartWidth = this.chartDiv.clientWidth;
    var c = this;
    window.addEventListener("resize", function () {
      c.resize();
    });
  };

  SvgChart.prototype.chartTitle = null;
  SvgChart.prototype.chartDiv = null;
  SvgChart.prototype.viewDiv = null;
  SvgChart.prototype.viewList = null;
  SvgChart.prototype.techGroupList = null;
  SvgChart.prototype.mainMapping = null;
  SvgChart.prototype.mainTechnical = null;
  SvgChart.prototype.code = null;
  SvgChart.prototype.name = null;
  SvgChart.prototype.timeFrame = null;
  SvgChart.prototype.period = null;
  SvgChart.prototype.loadingDiv = null;
  SvgChart.prototype.errorDiv = null;
  SvgChart.prototype.statusDiv = null;
  SvgChart.prototype.measureTextDiv = null;
  SvgChart.prototype.actionView = null;
  SvgChart.prototype.scrollView = null;
  SvgChart.prototype.rangeView = null;
  SvgChart.prototype.timeFormat = null;
  SvgChart.prototype.detailTimeFormat = null;
  SvgChart.prototype.language = null;
  SvgChart.prototype.server = null;
  SvgChart.prototype.colorIndex = 0;
  SvgChart.prototype.colorSelectList = {};
  SvgChart.prototype.addBenchmarkFundTitleFlag = false;
  SvgChart.prototype.indicatorLabels = [];
  SvgChart.prototype.timeFrameUpdated = true;
  SvgChart.timeFormatFunc = null;
  SvgChart.numberFormatFunc = null;
  SvgChart.translateFunc = null;
  SvgChart.prototype.benchmarkList = {};
  SvgChart.prototype.prepareBenchmarks = function () {
    //#5504
    var dataLoadUrl = "json/benchmark";
    var t = this;
    SvgChartUtil.jsonp({
      url: dataLoadUrl,
      jsonpCallback: "callback",
      jsonpCallbackFix: true,
      success: function (data) {
        for (let k in data) {
          var date = new Date(data[k]);
          var string = date.Format("yyyy-MM-dd");
          t.benchmarkList[k] = new Date(
            new Date(string).getTime()
          ).toISOString();
        }
      },
    });
  };

  SvgChart.prototype.setParams = function (code, name, exchange, config) {
    this.noDataMessage = "noData_simple";
    this.loadFailMessage = "loadFail_simple";

    this.chartConfig = MST.deepMerge(MST.SvgChartConfig(), config);

    this.showScroll = this.chartConfig.scroll.showScroll;
    this.showController = this.chartConfig.controller.showController;
    if (!Raphael.svg) {
      this.chartConfig.controller.showIndicator = false;
      this.chartConfig.controller.showBenchmark = false;
    }

    this.setPeriod("daily");

    this.code = code;
    this.name = name;
    this.exchange = exchange;

    this.showFund = false;

    if (this.loadingDiv == null) {
      this.init();
    }

    this.techGroupList = new Array();

    var technicalList = this.chartConfig.technicalList;
    for (var i = 0; i < technicalList.length; i++) {
      var techGroup = new Array();
      this.techGroupList.push(techGroup);
      for (var j = 0; j < technicalList[i].length; j++) {
        var name = technicalList[i][j];
        var tech = new SvgChartTechnical();
        tech.setName(this, name);
        techGroup.push(tech);

        if (i == 0 && j == 0) {
          tech.code = this.code;
          tech.setLoadType(
            SvgChartTechnical.DATA_LOAD_TYPE_URL,
            MST.getDataUrl(this.code, this.period)
          );
          this.mainTechnical = tech;
          this.colorSelectList[tech.dataColor[0]] = tech.dataColor[0];
        }

        if (name == "volume") {
          this.showVolume = true;
        }
        if (name == "fundLine") {
          this.showFund = true;
        }
      }
    }

    this.initIndicatorList(this.chartConfig.indicatorList);
    this.prepareView();
    this.prepareActionView();

    if (this.chartConfig.controller.showController) {
      this.controllerView.init();
    }

    this.timeFrame = "1Y";
    this.controllerView.rangeView.setChartType();

    this.setParams1();

    // unnessary for now, legacy code
    // this.prepareBenchmarks();
    this.checkPeriod("daily", ["3M", "6M", "1Y"]);
    this.checkPeriod("monthly", ["3Y", "5Y", "10Y"]);
  };

  SvgChart.prototype.setParams1 = function () {
    this.loadData();

    this.globalLoadingDiv.style.visibility = "hidden";
  };

  SvgChart.prototype.setTwoDaysChart = function (
    code,
    name,
    exchange,
    options
  ) {
    this.noDataMessage = "noData_simple";
    this.loadFailMessage = "loadFail_simple";

    this.chartConfig = MST.deepMerge(MST.SvgChartConfig(), options);
    this.timeFrame = this.chartConfig.controller.timeFrame;
    this.showRange = false;
    this.showIndicator = false;
    this.showScroll = false;
    this.showLabel = false;
    this.showPick = false;
    this.timeFrameUpdated = false;
    if (options != null && options.heightList != null)
      this.heightList = options.heightList;

    this.code = code;
    this.name = name;
    this.exchange = exchange;
    this.setPeriod("1m");

    if (this.loadingDiv == null) {
      this.init();
    }

    this.techGroupList = new Array();

    var techList = new Array();
    this.techGroupList.push(techList);

    var techCandle = new SvgChartTechnical();
    techCandle.setName(this, "twoDays");
    techCandle.code = this.code;
    techList.push(techCandle);
    var option = {
      limit: (25 * 60) / parseInt(this.period.substring(0, 1)),
      isGetDate: true,
    };
    if (this.intradayTimeDate != null) {
      option["begin_at"] = this.intradayTimeDate;
    }
    techCandle.setLoadType(
      SvgChartTechnical.DATA_LOAD_TYPE_URL,
      MST.getDataUrl(this.code, this.period, option)
    );

    this.mainTechnical = techCandle;

    // Prepare chart div layout
    this.prepareView();
    this.prepareActionView();

    this.hasWeekData();

    this.setTwoDaysChart1();
  };

  SvgChart.prototype.setTwoDaysChart1 = function () {
    var t = this;
    if (
      !t.range_daily_ready ||
      !t.range_weekly_ready ||
      !t.range_monthly_ready
    ) {
      setTimeout(function () {
        t.setTwoDaysChart1();
      }, 200);
      return;
    }

    // Load chart data
    this.loadData();

    this.globalLoadingDiv.style.visibility = "hidden";
  };

  SvgChart.prototype.checkPeriod = function (period, ranges) {
    var url = MST.getDataUrl(this.code, period);
    var t = this;
    var func = function (data) {
      var len = data.data.length;
      if (len == 0) {
        let periodFlg = {};
        periodFlg[period] = "nodata";
        var rangeLinks = t.controllerView.rangeView.rangeLinks;
        for (var i = 0; i < rangeLinks.length; i++) {
          var link = rangeLinks[i];
          for (var j = 0; j < ranges.length; j++) {
            if (link.rangeKey == ranges[j]) {
              link.onclick = null;
              link.className = "disabled";
            }
          }
        }
      }
    };
    MST.SvgChartUtil.jsonp({
      url: url,
      jsonpCallback: "chart_callback_" + period,
      timeout: 15,
      success: func,
    });
  };

  SvgChart.prototype.hasWeekData_count = 0;
  SvgChart.prototype.hasWeekData = function (compute_range) {
    if (this.hasWeekData_count > 10) {
      return;
    }
    this.hasWeekData_count += 1;
    if (!this.chartConfig.controller.showChartRange) {
      return;
    }
    var t = this;

    t.rangeLinks = {};
    t.range_daily_ready = false;
    t.range_weekly_ready = false;
    t.range_monthly_ready = false;

    var url_daily = MST.getDataUrl(this.code, "daily");
    var function_daily = function (data) {
      t.range_daily_ready = true;
      var len = data.data.length;
      var range = "6M";

      if (len < 250) {
        t.rangeLinks["1Y"] = "disabled";
        t.rangeLinks["5Y"] = "disabled";
        t.rangeLinks["10Y"] = "disabled";
        var rangeLinks = t.controllerView.rangeView.rangeLinks;
        for (var i = 0; i < rangeLinks.length; i++) {
          var link = rangeLinks[i];
          if (
            link.rangeKey == "1Y" ||
            link.rangeKey == "5Y" ||
            link.rangeKey == "10Y"
          ) {
            link.onclick = null;
            link.className = "disabled";
          }
        }
      }

      if (len < 120) {
        range = "3M";
        t.rangeLinks["6M"] = "disabled";
        t.rangeLinks["YTD"] = "disabled";
        var rangeLinks = t.controllerView.rangeView.rangeLinks;
        for (var i = 0; i < rangeLinks.length; i++) {
          var link = rangeLinks[i];
          if (link.rangeKey == "6M" || link.rangeKey == "YTD") {
            link.onclick = null;
            link.className = "disabled";
          }
        }
      }
      if (len < 60) {
        range = "1M";
        t.rangeLinks["3M"] = "disabled";
        var rangeLinks = t.controllerView.rangeView.rangeLinks;
        for (var i = 0; i < rangeLinks.length; i++) {
          var link = rangeLinks[i];
          if (link.rangeKey == "3M") {
            link.onclick = null;
            link.className = "disabled";
          }
        }
      }
      if (len == 0) {
        //			t.statusDiv.style.visibility = "visible";
      } else {
        if (compute_range) {
          t.timeFrame = range;
          t.controllerView.rangeView.setChartType();
          t.loadData();
        }
      }
      MST.SvgChartCache.save(url_daily, "daily", data);
    };

    var data = MST.SvgChartCache.load(url_daily);
    if (data != null) {
      function_daily(data);
    } else {
      MST.SvgChartUtil.jsonp({
        url: url_daily,
        jsonpCallback: "chart_callback_daily",
        timeout: 15,
        success: function_daily,
        fail: function () {
          t.hasWeekData(compute_range);
        },
      });
    }

    var url_weekly = MST.getDataUrl(this.code, "weekly");
    var function_weekly = function (data) {
      t.range_weekly_ready = true;
      if (data.data.length < 52) {
        t.rangeLinks["1Y"] = "disabled";
        var rangeLinks = t.controllerView.rangeView.rangeLinks;
        for (var i = 0; i < rangeLinks.length; i++) {
          var link = rangeLinks[i];
          if (link.rangeKey == "1Y") {
            link.onclick = null;
            link.className = "disabled";
          }
        }
      }
      MST.SvgChartCache.save(url_weekly, "weekly", data);
    };

    var data = MST.SvgChartCache.load(url_weekly);
    if (data != null) {
      function_weekly(data);
    } else {
      MST.SvgChartUtil.jsonp({
        url: url_weekly,
        jsonpCallback: "chart_callback_week",
        timeout: 15,
        success: function_weekly,
        fail: function () {
          t.hasWeekData(compute_range);
        },
      });
    }

    var url_monthly = MST.getDataUrl(this.code, "monthly");
    var function_monthly = function (data) {
      t.range_monthly_ready = true;
      if (data.data.length < 120) {
        t.rangeLinks["10Y"] = "disabled";
        var rangeLinks = t.controllerView.rangeView.rangeLinks;
        for (var i = 0; i < rangeLinks.length; i++) {
          var link = rangeLinks[i];
          if (link.rangeKey == "10Y") {
            link.onclick = null;
            link.className = "disabled";
          }
        }
      }
      if (data.data.length < 60) {
        t.rangeLinks["5Y"] = "disabled";
        var rangeLinks = t.controllerView.rangeView.rangeLinks;
        for (var i = 0; i < rangeLinks.length; i++) {
          var link = rangeLinks[i];
          if (link.rangeKey == "5Y") {
            link.onclick = null;
            link.className = "disabled";
          }
        }
      }
      MST.SvgChartCache.save(url_monthly, "monthly", data);
    };

    var data = MST.SvgChartCache.load(url_monthly);
    if (data != null) {
      function_monthly(data);
    } else {
      MST.SvgChartUtil.jsonp({
        url: url_monthly,
        jsonpCallback: "chart_callback_month",
        timeout: 15,
        success: function_monthly,
        fail: function () {
          t.hasWeekData(compute_range);
        },
      });
    }
  };

  SvgChart.prototype.initIndicatorList = function (indicatorList) {
    if (indicatorList != null) {
      for (var name in indicatorList) {
        var technical = MST.technicalConfig[name];
        if (technical == null) continue;

        if (technical.plural) {
          for (var i = 0; i < indicatorList[name].length; i++) {
            this.initIndicator(name, indicatorList[name][i]);
          }
        } else {
          this.initIndicator(name, indicatorList[name]);
        }
      }
    }
  };

  SvgChart.prototype.initIndicator = function (name, params) {
    var tech = new SvgChartTechnical();
    tech.setName(this, name);
    if (params != null) {
      tech.params = params.slice(0);
    }

    if (tech.type == "sub") {
      var techList = new Array();
      this.techGroupList.push(techList);

      techList.push(tech);
      return true;
    } else {
      this.techGroupList[0].push(tech);
      return false;
    }
  };

  /**
SvgChart.prototype.getPortfolioName = function(url) {

	var mychart = this;

	SvgChartUtil.jsonp({
		url : url,
		jsonpCallback : "chart_callback_p"+new Date().getTime(),
		success : function(data) {
			mychart.portfolio_1(data.name, data._embedded.currency.symbol);
		},
		fail : function() {
			mychart.retryCount += 1;
			if(mychart.retryCount < SvgChartTechnical.DATA_MAX_RETRY_COUNT){
				mychart.getPortfolioName(url);
			}
			else{
				mychart.timeout();
			}
		}
	});
};
**/

  /**
   *
   * @param {Object} code
   * @param {Object} name
   * @param {Object} isIndex  if it's a index but not a stock,we can't get the exchange name from MDD,so
   *        set exchange time in the conf.js by using the index name as the key
   */
  SvgChart.prototype.setSimpleChart = function (code, name, exchange, options) {
    this.noDataMessage = "noData_simple";
    this.loadFailMessage = "loadFail_simple";
    // var period = "5m";
    var period = "1m";
    this.defaultUnitCount = 12 * 24;
    this.showRange = false;
    this.showIndicator = false;
    this.showScroll = false;
    this.showLabel = false;
    this.showPick = false;
    this.timeFrameUpdated = false;
    if (options != null && options.heightList != null)
      this.heightList = options.heightList;

    if (this.loadingDiv == null) {
      this.init();
    }

    this.code = code;
    this.name = name;
    this.setPeriod(period);

    // //Gu 20140905 get the start time for Intraday Chart
    // var intradayTimeUrl = this.getDataUrl(code, period, {isGetDate:true});
    // this.getIntradayStartTime(intradayTimeUrl);

    // this.getExchange();
    this.exchange = exchange;
    this.setSimpleChart_1();
  };

  SvgChart.prototype.setSimpleChartDate = function (date) {
    this.intradayTimeDate = date;
  };

  SvgChart.prototype.exchange = null;
  SvgChart.prototype.intradayTime = null;
  SvgChart.prototype.lastClose = null;
  SvgChart.prototype.intradayTimeDate = null;

  SvgChart.prototype.setSimpleChart_1 = function () {
    var intradayTime = this.intradayTime;

    this.techGroupList = new Array();

    var techList = new Array();
    this.techGroupList.push(techList);

    var techCandle = new SvgChartTechnical();
    techCandle.setName(this, "intraday");
    techCandle.code = this.code;
    techList.push(techCandle);
    //techCandle.setLoadType(SvgChartTechnical.DATA_LOAD_TYPE_URL, this.getDataUrl(code, period));
    var option = {
      limit: (15 * 60) / parseInt(this.period.substring(0, 1)),
      isGetDate: true,
    };
    if (this.intradayTimeDate != null) {
      option["begin_at"] = this.intradayTimeDate;
    }
    techCandle.setLoadType(
      SvgChartTechnical.DATA_LOAD_TYPE_URL,
      this.getDataUrl(this.code, this.period, option)
    );

    this.mainTechnical = techCandle;

    // Prepare chart div layout
    this.prepareView();
    this.prepareActionView();

    // Load chart data
    this.loadData();
  };

  //get the date of the newest stock price for the Intraday chart
  SvgChart.prototype.getIntradayStartTime = function (url) {
    var mychart = this;

    SvgChartUtil.jsonp({
      url: url,
      jsonpCallback: "chart_callback",
      success: function (data) {
        //time format:2014-07-18T05:45:00.000+00:00
        // alert(data);
        var time = data[0]["date"];
        var date = time.split("T")[0];
        // alert(date+"T00:00:00.000+00:00");
        // date = "2014-07-18";
        mychart.intradayTime = date;
        var close = data[0]["close"];
        // close = 7642;
        mychart.lastClose = close;
        mychart.setSimpleChart_1();
      },
      fail: function () {
        mychart.timeout();
      },
    });
  };

  //TODO GH
  //serverTime is UTC time
  SvgChart.setCurrentTime = function (serverTime) {
    //TODO if the currentTime is not setted ,throw new Error("Current time not provided");
    //SvgChart.currentTime = serverTime;
  };

  SvgChart.prototype.setRatingDotColor = function (c1, c2) {
    this.pickColors = [c1, c2];
  };

  SvgChart.prototype.setBenchmarks = function (obj) {
    this.indicatorViewBenchmarks = obj;

    for (let i in this.indicatorViewBenchmarks) {
      SvgChartGlobal.lang.select[i] = this.indicatorViewBenchmarks[i].name;
    }
  };

  SvgChart.prototype.setIndicators = function (obj) {
    this.indicatorViewIndicators = obj;
  };

  SvgChart.prototype.setAverages = function (obj) {
    this.indicatorViewAverages = obj;
  };

  SvgChart.setTimeFormatFunction = function (func) {
    SvgChart.timeFormatFunc = func;
  };

  SvgChart.setNumberFormatFunction = function (func) {
    SvgChart.numberFormatFunc = func;
  };

  /**
   *GU 20141008 in order to customize depot api url
   * @param {Object} func
   */
  SvgChart.setDepotValueUrlFunction = function (func) {
    SvgChart.depotValueUrlFunc = func;
  };

  SvgChart.setTranslateFunction = function (func) {
    SvgChart.translateFunc = func;
  };

  /**
   * Comment by GU 20141021:We can't show more than one big chart for different rics in one page,because rics can be customized currently.
   * In order to avoid this problem,we need to change setRatingUrlFunction to prototype.
   */
  SvgChart.prototype.setRatingUrlFunction = function (func) {
    this.ratingUrlFunc = func;
  };

  SvgChart.prototype.init = function () {
    if (this.language == null) {
      this.setLanguage(SvgChartGlobal.language);
    }

    this.chartDiv.className = "SvgChart";
    this.chartDiv.style.position = "relative";

    this.viewDiv = document.createElement("div");
    this.viewDiv.style.position = "relative";
    this.loadingDiv = document.createElement("div");
    this.errorDiv = document.createElement("div");

    this.loadingDiv.className = "svgChartLoading";
    this.errorDiv.className = "svgChartError";

    // Loading div
    // this.loadingDiv.style.lineHeight = "200px";
    this.loadingDiv.style.position = "absolute";
    this.loadingDiv.style.width = "100%";
    this.loadingDiv.style.height = "100%";
    this.loadingDiv.style.zIndex = 9;
    this.loadingDiv.style.textAlign = "center";
    this.loadingDiv.style.visibility = "hidden";

    // error div
    // this.errorDiv.style.lineHeight = "200px";
    this.errorDiv.style.position = "absolute";
    this.errorDiv.style.width = "100%";
    this.errorDiv.style.height = "100%";
    this.errorDiv.style.zIndex = 9;
    this.errorDiv.style.textAlign = "center";
    this.errorDiv.style.visibility = "hidden";
    // this.errorDiv.innerHTML = "Loading is failed.Please try again later.";
    this.errorDiv.innerHTML =
      "<div>" + this.getLabel(this.loadFailMessage) + "</div>";

    // measureText div
    this.measureTextDiv = document.createElement("div");
    this.measureTextDiv.className = "SvgText";
    this.measureTextDiv.style.position = "absolute";
    this.errorDiv.appendChild(this.measureTextDiv);

    // status div
    this.statusDiv = document.createElement("div");
    this.statusDiv.className = "SvgChartStatus";

    this.statusDiv.style.lineHeight = "200px";
    this.statusDiv.style.position = "absolute";
    this.statusDiv.style.width = "100%";
    this.statusDiv.style.height = "100%";
    this.statusDiv.style.zIndex = 8;
    this.statusDiv.style.textAlign = "center";
    this.statusDiv.style.visibility = "hidden";
    // this.statusDiv.innerHTML = this.getLabel("no_data");
    //	this.statusDiv.innerHTML = "<div>" + this.getLabel(this.noDataMessage) + "</div>";
    var div = document.createElement("div");
    this.statusDiv.appendChild(div);
    div.appendChild(document.createTextNode(this.getLabel(this.noDataMessage)));

    this.backgroundView = new SvgChartBackground(this);

    this.chartDiv.appendChild(this.loadingDiv);
    this.chartDiv.appendChild(this.errorDiv);

    this.chartDiv.appendChild(this.statusDiv);

    this.globalLoadingDiv = document.createElement("div");
    this.globalLoadingDiv.className = "svgChartGlobalLoading";
    this.globalLoadingDiv.style.position = "absolute";
    this.globalLoadingDiv.style.width = "100%";
    this.globalLoadingDiv.style.height = "100%";
    this.globalLoadingDiv.style.zIndex = 9;
    this.chartDiv.appendChild(this.globalLoadingDiv);

    if (this.chartConfig.controller.showController) {
      this.controllerView = new SvgChartControllerView(this);
    }

    this.chartDiv.appendChild(this.viewDiv);

    //	if (this.chartConfig.actionView.active) {
    this.actionView = new SvgChartActionView(this, this.viewDiv);
    //	}

    if (this.showScroll) {
      this.scrollView = new SvgChartScrollView(this);
    }
  };

  SvgChart.prototype.prepareView = function (setRange) {
    if (setRange != null) {
      var dataStartIndex = this.viewList[0].mapping.dataStartIndex;
      var dataLength = this.viewList[0].mapping.dataLength;
    }

    if (this.viewList != null) {
      for (var i = this.viewList.length - 1; i >= 0; i--) {
        this.viewDiv.removeChild(this.viewList[i].frameDiv);
      }

      // clear settingPanel cache  of technical
      for (var k = 0; k < this.techGroupList.length; k++) {
        for (var m = 0; m < this.techGroupList[k].length; m++) {
          this.techGroupList[k][m].settingPanel = null;
        }
      }
    }
    this.viewList = new Array();
    for (var i = 0; i < this.techGroupList.length; i++) {
      var view = new SvgChartView(this, i);
      this.viewList.push(view);
    }

    if (setRange != null) {
      for (var i = 0; i < this.viewList.length; i++) {
        this.viewList[i].mapping.setDataRange(dataStartIndex, dataLength);
      }
    }
  };

  SvgChart.prototype.prepareActionView = function () {
    this.actionView.drawAreaHeight = 0;
    this.actionView.dataList = new Array();

    this.backgroundView.drawAreaHeight = 0;

    for (var i = 0; i < this.viewList.length; i++) {
      this.actionView.drawAreaHeight += this.viewList[i].mapping.drawAreaHeight;
      this.backgroundView.drawAreaHeight +=
        this.viewList[i].mapping.drawAreaHeight + 2;
      for (var j = 0; j < this.viewList[i].technicalList.length; j++) {
        this.actionView.dataList.push(this.viewList[i].technicalList[j]);
      }
    }
    this.actionView.actionCanvasDiv.childNodes[0].style.height =
      this.actionView.drawAreaHeight + "px";

    // this.backgroundView.drawAreaHeight += 50;
    if (this.chartConfig.controller.showIndicator) {
      this.controllerView.indicatorControllerView.viewDiv.style.maxHeight =
        this.actionView.drawAreaHeight + "px";
      this.controllerView.indicatorControllerView.viewDiv.style.overflowY =
        "auto";
    }
  };

  SvgChart.prototype.addVolume = function () {
    this.addTechnical("volume");
    this.showVolume = true;
  };

  SvgChart.prototype.removeVolume = function () {
    this.removeTechnical("volume");
    this.showVolume = false;
  };

  SvgChart.prototype.addTechnical = function (name) {
    for (var i = 1; i < this.techGroupList.length; i++) {
      // console.log(this.techGroupList[i][0].name);
      if (this.techGroupList[i][0].name == name) {
        return;
      }
    }
    for (var i = 1; i < this.techGroupList[0].length; i++) {
      // console.log(this.techGroupList[0][i].name);
      if (this.techGroupList[0][i].name == name) {
        return;
      }
    }

    var technical = SvgChartTechnical.technicalMaster[name];
    if (technical == null) return;

    var tech = new SvgChartTechnical();
    tech.setName(this, name);

    if (technical.type == "sub") {
      var techList = new Array();
      this.techGroupList.push(techList);

      techList.push(tech);

      this.addView(techList);
    } else {
      this.techGroupList[0].push(tech);
      this.viewList[0].setTechnicalList(this.techGroupList[0]);
      this.prepareActionView();
      this.analysis();
      this.viewList[0].mapping.updated = true;
      this.viewList[0].draw();
    }
    if (this.drawFinish != null) {
      this.drawFinish();
    }
  };

  SvgChart.prototype.removeTechnical = function (techId) {
    for (var i = this.techGroupList.length - 1; i >= 0; i--) {
      if (i > 0) {
        if (this.techGroupList[i][0].techId == techId) {
          this.viewDiv.removeChild(this.viewList[i].frameDiv);
          this.techGroupList.splice(i, 1);
          this.removeView(i);
        }
      }
    }
    for (var i = this.techGroupList[0].length - 1; i > 0; i--) {
      // console.log(this.techGroupList[0][i].techId);
      if (this.techGroupList[0][i].techId == techId) {
        this.techGroupList[0].splice(i, 1);
        this.prepareActionView();
        this.viewList[0].setTechnicalList(this.techGroupList[0]);
        this.viewList[0].mapping.updated = true;
        this.viewList[0].draw();
      }
    }
    this.drawAll();
  };

  SvgChart.prototype.addView = function (techGroup) {
    let view = new SvgChartView(this, this.techGroupList.length - 1);
    this.viewList.push(view);
    var dataStartIndex = this.viewList[0].mapping.dataStartIndex;
    var dataLength = this.viewList[0].mapping.dataLength;
    this.viewList[this.techGroupList.length - 1].mapping.setDataRange(
      dataStartIndex,
      dataLength
    );
    this.prepareActionView();
    view.loadData();
  };

  SvgChart.prototype.removeView = function (i) {
    this.viewList.splice(i, 1);
    this.prepareActionView();
  };

  SvgChart.prototype.changeMainTechnical = function (name) {
    var dataColor = this.mainTechnical.dataColor;
    var lineWidth = this.mainTechnical.lineWidth;
    var technicalName = this.mainTechnical.name;
    this.mainTechnical.setName(this, name);
    this.mainTechnical.dataColor = dataColor;
    this.mainTechnical.lineWidth = lineWidth;

    if (this.period == "1m" && technicalName != "candle" && name == "candle") {
      this.changeTimeFrame("3M");
      this.period = "daily";
    }

    this.viewList[0].setTechnicalList(this.viewList[0].technicalList);
    this.viewList[0].mapping.updated = true;

    if (this.chartConfig.controller.showChartRange) {
      this.controllerView.rangeView.setChartType(
        name,
        this.mainMapping.benchmark
      );
    }

    this.draw();
  };

  SvgChart.prototype.redraw = function () {
    this.resize();
  };

  SvgChart.prototype.resize = function () {
    this.prepareActionView();
    if (
      this.actionView != null &&
      this.actionView.mapping.status == SvgChartTechnical.DATA_STATUS_OK
    ) {
      this.draw();
      if (this.showScroll) {
        this.scrollView.draw();
      }
    }
    // this.rangeView.rangeViewDiv.style.width = this.chartDiv.clientWidth - 16 + "px";
  };

  SvgChart.prototype.loadData = function () {
    for (var i = 0; i < this.viewList.length; i++) {
      var view = this.viewList[i];
      view.mapping.status = SvgChartTechnical.DATA_STATUS_LOADING;
      view.loadData();
    }
  };

  SvgChart.prototype.analysis = function () {
    // console.log("================analysis==================");

    for (var i = 0; i < this.techGroupList.length; i++) {
      for (var j = 0; j < this.techGroupList[i].length; j++) {
        var tech = this.techGroupList[i][j];
        if (tech.dataLoadType == SvgChartTechnical.DATA_ANALYSIS) {
          tech.analysis.analysis(tech, this.mainTechnical.data);
        }

        if (
          i == 0 &&
          j > 0 &&
          tech.type != "dummy" &&
          tech.dataLoadType == SvgChartTechnical.DATA_LOAD_TYPE_URL
        ) {
          tech.data = tech.analysisBenchmark(
            tech.data,
            this.mainTechnical.data,
            16
          );
        }

        if (i == 0 && tech.name == "lastClose") {
          tech.analysisLastClose(this.mainTechnical.data);
        }
      }
    }
  };

  SvgChart.prototype.onStatusChange = function () {
    var dataReady = true;
    var dataFailure = false;
    var noData = false;

    for (var i = 0; i < this.viewList.length; i++) {
      var view = this.viewList[i];
      if (view.mapping.status != SvgChartTechnical.DATA_STATUS_OK) {
        dataReady = false;

        if (view.mapping.status == SvgChartTechnical.DATA_STATUS_FAILURE) {
          dataFailure = true;
        }

        if (view.mapping.status == SvgChartTechnical.DATA_STATUS_NO_DATA) {
          noData = true;
        }
      }
    }

    if (noData == true) {
      var compare_box = document.getElementById("chart_compare_box");
      if (compare_box != null) {
        compare_box.style.visibility = "hidden";
      }

      this.loadingDiv.style.visibility = "hidden";
      this.errorDiv.style.visibility = "hidden";
      this.statusDiv.style.visibility = "visible";
      //this.indicatorLabelDiv.style.visibility = "hidden";
      if (this.indicatorView) {
        this.indicatorView.indicatorLabelDiv.style.visibility = "hidden";
      }

      //		if (this.chartConfig.actionView.active) {
      this.actionView.mapping.setStatus(SvgChartTechnical.DATA_STATUS_NO_DATA);
      //		}
    } else if (dataFailure == true) {
      this.loadingDiv.style.visibility = "hidden";
      this.errorDiv.style.visibility = "visible";
      this.statusDiv.style.visibility = "hidden";
      if (this.indicatorView) {
        this.indicatorView.indicatorLabelDiv.style.visibility = "hidden";
      }

      //		if (this.chartConfig.actionView.active) {
      this.actionView.mapping.setStatus(SvgChartTechnical.DATA_STATUS_FAILURE);
      //		}
    } else if (dataReady == false) {
      this.loadingDiv.style.visibility = "visible";
      this.errorDiv.style.visibility = "hidden";
      //this.indicatorView.indicatorLabelDiv.style.visibility = "hidden";
      //this.statusDiv.style.visibility = "hidden";

      //		if (this.chartConfig.actionView.active) {
      this.actionView.mapping.setStatus(SvgChartTechnical.DATA_STATUS_LOADING);
      //		}
    } else {
      //while noData occurs,we should hide indicator div.it's just temp solution from GU 20141027
      if (this.indicatorView) {
        this.indicatorView.indicatorLabelDiv.style.visibility = "visible";
      }
      //End

      if (this.rangeView) {
        this.rangeView.rangeViewDiv.style.visibility = "visible";
      }
      this.draw();

      if (this.showScroll) {
        this.scrollView.draw();
      }

      //		if (this.chartConfig.actionView.active) {
      this.actionView.mapping.setStatus(SvgChartTechnical.DATA_STATUS_OK);
      //		}

      this.loadingDiv.style.visibility = "hidden";
      this.errorDiv.style.visibility = "hidden";
      this.statusDiv.style.visibility = "hidden";
      if (this.showIndicator) {
        this.indicatorView.showMenu();
      }

      if (this.loadFinish != null) {
        this.loadFinish();
        this.loadFinish = null;
      }
    }
  };

  SvgChart.prototype.timeout = function () {
    this.loadingDiv.style.visibility = "hidden";
    this.errorDiv.style.visibility = "visible";
    this.statusDiv.style.visibility = "hidden";

    if (this.active) {
      this.actionView.mapping.setStatus(SvgChartTechnical.DATA_STATUS_FAILURE);
    }
  };

  SvgChart.prototype.draw = function () {
    // this.backgroundView.drawBackground();
    this.actionView.dataDiv.style.visibility = "hidden";
    this.actionView.xAxisDiv.style.visibility = "hidden";
    this.actionView.yAxisDiv.style.visibility = "hidden";
    for (var i = 0; i < this.viewList.length; i++) {
      var view = this.viewList[i];
      view.draw();
    }
    if (this.drawFinish != null) {
      this.drawFinish();
    }

    var startIndex = this.viewList[0].mapping.dataStartIndex_data;
    var mainDate = this.mainTechnical.data[startIndex].date;
    for (var key in this.benchmarkObjs) {
      var date = this.benchmarkList[key + "_" + this.period];
      var benchmark = this.indicatorViewBenchmarks[key];
      if (benchmark == null || date == null) continue;
      if (benchmark.type != "futures" && benchmark.type != "index") continue;

      if (mainDate < date) {
        this.benchmarkObjs[key].disabled = true;
        this.benchmarkObjs[key].checkboxLabel.style.color = "#EEE";
      } else {
        this.benchmarkObjs[key].disabled = false;
        this.benchmarkObjs[key].checkboxLabel.style.color = "";
      }
    }
    if (typeof checkChartBenchmark === "function") {
      checkChartBenchmark(mainDate, this.benchmarkList, this.period);
    }
  };

  SvgChart.prototype.drawAll = function () {
    this.analysis();
    this.actionView.dataDiv.style.visibility = "hidden";
    this.actionView.xAxisDiv.style.visibility = "hidden";
    this.actionView.yAxisDiv.style.visibility = "hidden";
    for (var i = 0; i < this.viewList.length; i++) {
      var view = this.viewList[i];
      view.setTechnicalList(view.technicalList);
      view.mapping.updated = true;
      view.draw();
    }
    if (this.showScroll) {
      this.scrollView.draw();
    }
    if (this.showController) {
      this.controllerView.init();
    }
  };

  SvgChart.prototype.drawTimer = null;
  SvgChart.prototype.setDataRange = function (dataStartIndex, dataLength) {
    // Update mapping of sub charts
    for (var i = 0; i < this.viewList.length; i++) {
      this.viewList[i].mapping.setDataRange(dataStartIndex, dataLength);
    }

    if (this.chartConfig.scroll.showScroll) {
      this.scrollView.mapping.setDataRange(dataStartIndex, dataLength);
      this.scrollView.drawScrollAction();
    }
    // Redraw all chart
    (function (t) {
      if (t.drawTimer != null) {
        clearTimeout(t.drawTimer);
      }
      t.drawTimer = setTimeout(function () {
        t.draw();
      }, 10);
    })(this);
    // this.draw();
  };

  SvgChart.prototype.setPeriod = function (period) {
    this.period = period;
    this.timeFormat = SvgChartUtil.getTimeFormat(period);
    this.detailTimeFormat = SvgChartUtil.getTimeFormat(period, "detail");
  };

  SvgChart.prototype.changePeriod = function (period) {
    this.setPeriod(period);
    if (this.viewList[0].mapping.benchmark == true) {
      for (var i = 0; i < this.viewList[0].technicalList.length; i++) {
        var tech = this.viewList[0].technicalList[i];
        if (tech.dataLoadType != SvgChartTechnical.DATA_LOAD_TYPE_URL) continue;
        tech.setLoadType(
          SvgChartTechnical.DATA_LOAD_TYPE_URL,
          MST.getDataUrl(tech.code, period)
        );
      }
    } else {
      this.mainTechnical.setLoadType(
        SvgChartTechnical.DATA_LOAD_TYPE_URL,
        MST.getDataUrl(this.code, period)
      );
    }

    for (var i = 0; i < this.techGroupList.length; i++) {
      this.viewList[i].mapping.setDataRange(0, 0);
      for (var j = 0; j < this.techGroupList[i].length; j++) {
        this.techGroupList[i][j].dataStatus =
          SvgChartTechnical.DATA_STATUS_INIT;
      }
    }

    this.loadData();
  };

  SvgChart.prototype.findBenchmark = function (code) {
    for (var i = 1; i < this.techGroupList[0].length; i++) {
      if (this.techGroupList[0][i].code == code) {
        return this.techGroupList[0][i];
      }
    }
    return null;
  };

  SvgChart.prototype.findIndicator = function (name) {
    for (var i = this.techGroupList.length - 1; i > 0; i--) {
      if (this.techGroupList[i][0].name == name) {
        return this.techGroupList[i][0];
      }
    }
    for (var i = this.techGroupList[0].length - 1; i > 0; i--) {
      if (this.techGroupList[0][i].name == name) {
        return this.techGroupList[0][i];
      }
    }
    return null;
  };

  SvgChart.prototype.checkExistBenchmarkIndex = function (code) {
    if (this.benchmarks == null || this.benchmarks.length == 0) return -1;

    var index = -1;

    for (var i = 0; i < this.benchmarks.length; i++) {
      if (code == this.benchmarks[i]) {
        index = i;
        break;
      }
    }

    return index;
  };

  SvgChart.prototype.getSelectColor = function () {
    var pickupColor =
      SvgChartGlobal.COLOR_PANEL[SvgChartGlobal.COLOR_PANEL.length - 1];

    for (var i = 0; i < SvgChartGlobal.COLOR_PANEL.length; i++) {
      var color = SvgChartGlobal.COLOR_PANEL[i];

      if (this.colorSelectList[color] == null) {
        pickupColor = color;
        this.colorSelectList[color] = color;
        break;
      }
    }

    return pickupColor;
  };

  SvgChart.prototype.setBenchmarksIndicators = function () {
    if (this.color_panel_cache == null) {
      this.color_panel_cache = {};
    }

    for (var t = 1; t < this.techGroupList[0].length; t++) {
      if (this.techGroupList[0][t].code != null) {
        this.color_panel_cache[this.techGroupList[0][t].code] =
          this.techGroupList[0][t].dataColor;
      }
    }

    var benchmarks = [];
    //	var indicators = [];

    if (this.benchmarks == null) this.benchmarks = [];

    if (this.benchmarks.length > 0) {
      for (var i = 0; i < this.benchmarks.length; i++) {
        if (this.benchmarkObjs[this.benchmarks[i]] != null) {
          benchmarks.push(this.benchmarks[i]);
        }
      }
    }

    for (var i in this.benchmarkObjs) {
      if (this.benchmarkObjs[i].checked) {
        if (this.checkExistBenchmarkIndex(i) == -1) {
          benchmarks.push(i);
        }
      } else {
        var index = this.checkExistBenchmarkIndex(i);

        if (index != -1) {
          benchmarks.splice(index, 1);
        }
      }
    }

    this.benchmarks = benchmarks;

    if (benchmarks.length > 0) {
      // this.controllerView.typeControllerView.toggleStatus(false);
      // this.controllerView.indicatorControllerView.toggleStatus(false);
    } else {
      // this.controllerView.typeControllerView.toggleStatus(true);
      // this.controllerView.indicatorControllerView.toggleStatus(true);
    }

    //	var techGroupList = new Array();
    var techGroup = this.techGroupList[0];

    var begin_at = this.mainTechnical.data[0].date;
    var end_at =
      this.mainTechnical.data[this.mainTechnical.data.length - 1].date;
    var format = "YYYY/MM/DD";
    begin_at = new Date(begin_at).format(format);
    end_at = new Date(new Date(end_at).getTime() + 60 * 60 * 24).format(format);

    for (var i = techGroup.length - 1; i > 0; i--) {
      var tech = techGroup[i];
      if (tech.code == null) {
        // techGroup.splice(i, 1);
        continue;
      }

      var found = false;
      for (var b = 0; b < benchmarks.length; b++) {
        if (tech.code == benchmarks[b]) found = true;
      }
      if (!found) {
        var tech = techGroup.splice(i, 1)[0];
        tech.checkbox.colorPanel.style.backgroundColor = "#eee";
        tech.checkbox.colorPanel.style.cursor = "default";
      }
    }
    for (var i = 0; i < benchmarks.length; i++) {
      var tech = this.findBenchmark(benchmarks[i]);

      if (tech == null) {
        if (techGroup[0].code == benchmarks[i]) {
          tech = techGroup[0];
        } else {
          tech = new SvgChartTechnical();
          tech.code = benchmarks[i];
          tech.setName(this, "line");
          tech.dataColor[0] = this.getSelectColor();
          tech.isBenchmarks = true;
          tech.setLoadType(
            SvgChartTechnical.DATA_LOAD_TYPE_URL,
            MST.getDataUrl(tech.code, this.period, { begin_at: begin_at })
          );

          techGroup.push(tech);
        }
      }

      if (this.benchmarkObjs[benchmarks[i]] != null) {
        this.benchmarkObjs[benchmarks[i]].technical = tech;
        tech.checkbox = this.benchmarkObjs[benchmarks[i]];
      }
    }

    if (benchmarks.length == 0) {
      this.viewList[0].mapping.benchmark = false;

      var objs = this.chartTypeObjs;
      for (var l in objs) {
        var className = objs[l].className;
        className = className.replace("_selected", "");
        if (this.mainMapping.benchmark == false) {
          objs[l].className =
            l == this.mainTechnical.name ? className + "_selected" : className;
        }
      }
    } else {
      this.viewList[0].mapping.benchmark = true;

      for (var i = 0; i < benchmarks.length; i++) {
        if (this.benchmarkObjs[benchmarks[i]] != null) {
          this.benchmarkObjs[benchmarks[i]].colorPanel.style.backgroundColor =
            this.benchmarkObjs[benchmarks[i]].technical.dataColor[0];
          this.benchmarkObjs[benchmarks[i]].colorPanel.style.cursor = "pointer";
        }
      }
    }
    this.viewList[0].setTechnicalList(techGroup);

    this.loadData();
  };

  SvgChart.prototype.addBenchmark = function (code, index) {
    var techGroup = this.techGroupList[0];

    if (this.benchmarks == null) this.benchmarks = [];

    var tech = this.findBenchmark(code);
    var maxWidth = 420;

    if (tech == null) {
      tech = new SvgChartTechnical();
      tech.code = code;
      tech.setName(this, "line");
      tech.dataColor[0] = this.getSelectColor();
      this.colorSelectList[tech.dataColor[0]] = tech.dataColor[0];
      tech.vAxis.vAxis = index;
      tech.isBenchmarks = true;
      //		tech.setLoadType(SvgChartTechnical.DATA_LOAD_TYPE_URL, MST.getDataUrl(tech.code, this.period, {begin_at : begin_at}));
      tech.setLoadType(
        SvgChartTechnical.DATA_LOAD_TYPE_URL,
        MST.getDataUrl(tech.code, this.period)
      );

      for (var key in this.benchmarkObjs) {
        if (key == code) {
          this.benchmarkObjs[key].checked = true;
          this.benchmarkObjs[key].checkboxLabel.className = "cklabel-after";
          this.benchmarkObjs[key].colorPanel.style.backgroundColor =
            tech.dataColor[0];
          this.benchmarkObjs[key].colorPanel.style.cursor = "point";

          // if (this.chartWidth < maxWidth) {
          //   this.benchmarkObjs[key].checkboxLabel.style.maxWidth =
          //     this.chartWidth * 0.8 + "px";
          // }

          tech.checkbox = this.benchmarkObjs[key];
        }
      }

      techGroup.push(tech);
      this.benchmarks.push(code);
    }

    for (var k in this.chartTypeObjs) {
      var className = "icon_" + k;
      this.chartTypeObjs[k].className = className + " button_disable";
    }

    this.viewList[0].setTechnicalList(techGroup);
    this.viewList[0].mapping.benchmark = true;

    this.loadData();
  };

  SvgChart.prototype.setBenchmark = function (benchmarks) {
    if (techGroupList != null) {
      for (var i = 1; i < this.techGroupList[0].length; i++) {
        this.colorSelectList[this.techGroupList[0][i].dataColor[0]] = null;
      }
    }

    // chartControlBenchmark(benchmarks);

    this.benchmarks = benchmarks;
    var techGroupList = new Array();
    var techGroup = new Array();
    techGroupList.push(techGroup);
    if (this.techGroupList) {
      this.mainTechnical = this.techGroupList[0][0];
      techGroup.push(this.mainTechnical);
      techGroup.push(this.techGroupList[0][1]);
    }

    if (benchmarks.length > 0) {
      if (this.viewList) {
        this.viewList[0].mapping.benchmark = true;
      }

      // SvgChartGlobal.colorIndex = 1;
      for (var i = 0; i < benchmarks.length; i++) {
        var tech = new SvgChartTechnical();
        tech.code = benchmarks[i];
        tech.setName(this, "line");
        tech.dataColor[0] = this.getSelectColor();
        tech.setLoadType(
          SvgChartTechnical.DATA_LOAD_TYPE_URL,
          MST.getDataUrl(tech.code, this.period)
        );

        techGroup.push(tech);
      }
    } else {
      if (this.viewList) {
        this.viewList[0].mapping.benchmark = false;
      }
    }

    if (this.showRange && this.viewList) {
      this.rangeView.setChartType(
        this.mainTechnical.name,
        this.viewList[0].mapping.benchmark
      );
    }
    if (this.techGroupList) {
      for (var i = 1; i < this.techGroupList.length; i++) {
        techGroupList.push(this.techGroupList[i]);
      }
    }

    this.techGroupList = techGroupList;

    var dataStartIndex = this.viewList[0].mapping.dataStartIndex;
    var dataLength = this.viewList[0].mapping.dataLength;

    this.viewList[0].setTechnicalList(techGroup);
    // this.prepareView();
    this.prepareActionView();

    if (benchmarks.length == 0) {
      this.viewList[0].mapping.benchmark = false;

      for (var i = 0; i < this.viewList.length; i++) {
        this.viewList[i].mapping.setDataRange(dataStartIndex, dataLength);
        this.viewList[i].mapping.status = SvgChartTechnical.DATA_STATUS_OK;
        this.viewList[i].mapping.updated = true;
      }

      this.draw();
      this.setDataRange(dataStartIndex, dataLength);
    } else {
      this.viewList[0].mapping.benchmark = true;

      for (var i = 0; i < this.viewList.length; i++) {
        this.viewList[i].mapping.setDataRange(dataStartIndex, dataLength);
        this.viewList[i].mapping.status = SvgChartTechnical.DATA_STATUS_INIT;
        this.viewList[i].mapping.updated = true;
      }

      this.loadData();
    }
  };

  SvgChart.prototype.setTech = function (list) {
    for (var i = this.techGroupList.length - 1; i >= 2; i--) {
      this.viewDiv.removeChild(this.viewList[i].frameDiv);
      this.techGroupList.splice(i, 1);
      this.removeView(i);
    }

    for (var i = 0; i < list.length; i++) {
      this.initIndicator(list[i]);
      this.addView(this.techGroupList[this.techGroupList.length - 1]);
    }
    this.prepareActionView();
  };

  SvgChart.prototype.setScale = function (scale) {
    if (scale == "logarithmic") {
      this.viewList[0].mapping.logarithmic = true;
    } else {
      this.viewList[0].mapping.logarithmic = false;
    }

    // this.indicatorView.optionsControl();

    this.viewList[0].mapping.updated = true;

    this.draw();
  };

  SvgChart.prototype.setServer = function (server) {
    this.server = server;
  };

  SvgChart.prototype.setLanguage = function (lang) {
    this.language = lang;
    // SvgChartGlobal.loadLanguage(lang);

    var timeformat = SvgChartGlobal.timeformat[this.language];
    if (timeformat == null) {
      timeformat = SvgChartGlobal.timeformat[SvgChartGlobal.language];
    }
    SvgChartGlobal.timeformat.select = timeformat;

    var lang = SvgChartGlobal.lang[this.language];
    if (lang == null) {
      lang = SvgChartGlobal.lang[SvgChartGlobal.language];
    }
    SvgChartGlobal.lang.select = lang;
  };

  SvgChart.prototype.getLabel = function (label) {
    var t = SvgChartGlobal.lang.select[label];
    if (t == undefined) {
      return label;
    }
    return t;
  };

  SvgChart.prototype.exportJson = function () {
    var techGroupList = [];
    for (var i = 0; i < this.techGroupList.length; i++) {
      var techGroup = [];
      for (var j in this.techGroupList[i]) {
        var tech = this.techGroupList[i][j];
        var benchmark = tech.view.mapping.benchmark;
        if (benchmark) {
          techGroup.push("line");
        } else {
          techGroup.push(tech.name);
        }
      }
      techGroupList.push(techGroup);
    }

    var chart = {};
    chart.charttype = this.mainTechnical.name;

    if (this.showRange) {
      // chart.timeframe = this.rangeView.rangeSelect.value;
      // chart.charttype = this.rangeView.chartTypeSelect.value;
    }

    chart.dataStartIndex = this.mainMapping.dataStartIndex;
    chart.dataLength = this.mainMapping.dataLength;

    chart.code = this.code;
    chart.name = this.name;
    chart.period = this.period;
    chart.language = this.language;
    chart.benchmarks = this.benchmarks;
    chart.techList = techGroupList;
    chart.logarithmic = this.viewList[0].mapping.logarithmic;

    var str = JSON.stringify(chart);
    return str;
  };

  SvgChart.prototype.importJson = function (json) {
    // var chart = JSON.parse(json);
    var chart = json;

    this.showRange = true;
    this.showIndicator = false;
    this.showScroll = true;
    this.showLabel = true;
    this.active = true;
    // this.showPick = chart.showPick;
    this.timeFrameUpdated = false;

    this.code = chart.code;
    this.name = chart.name;
    this.setPeriod(chart.period);
    this.getExchange();

    if (this.loadingDiv == null) {
      this.init();
    }

    this.language = chart.language;
    var benchmark;
    if (chart.benchmarks != null && chart.benchmarks.length > 0) {
      this.benchmarks = chart.benchmarks;
      benchmark = true;
    } else {
      this.benchmarks = null;
      benchmark = false;
    }

    if (this.showRange) {
      this.rangeView.setChartType(chart.charttype, benchmark);
    }

    var techGroupList = new Array();
    this.techGroupList = techGroupList;

    for (var i = 0; i < chart.techList.length; i++) {
      var techGroup = [];
      var benchmarkIndex = 0;
      for (var j = 0; j < chart.techList[i].length; i++) {
        var name = chart.techList[i][j];

        var tech = new SvgChartTechnical();
        tech.setName(this, name);
        techGroup.push(tech);

        if (i == 0 && j == 0) {
          tech.code = this.code;
          tech.setLoadType(
            SvgChartTechnical.DATA_LOAD_TYPE_URL,
            MST.getDataUrl(this.code, this.period)
          );
          this.mainTechnical = tech;
        } else if (
          i == 0 &&
          j > 0 &&
          this.benchmarks != null &&
          name != "pick"
        ) {
          tech.code = this.benchmarks[benchmarkIndex];
          benchmarkIndex++;
          tech.setLoadType(
            SvgChartTechnical.DATA_LOAD_TYPE_URL,
            MST.getDataUrl(tech.code, this.period)
          );
        }
      }
      techGroupList.push(techGroup);
    }

    // Prepare chart div layout
    this.prepareView();
    this.prepareActionView();

    this.viewList[0].mapping.setDataRange(
      chart.dataStartIndex,
      chart.dataLength
    );
    if (this.benchmarks != null) {
      this.viewList[0].mapping.benchmark = true;
    }
    if (chart.logarithmic) {
      this.viewList[0].mapping.logarithmic = true;
    }

    // Load chart data
    this.loadData();
  };

  SvgChart.prototype.changeTimeFrame = function (timeFrame) {
    this.timeFrame = timeFrame;
    this.timeFrameUpdated = true;
    this.actionView.dataDiv.style.visibility = "hidden";
    this.actionView.xAxisDiv.style.visibility = "hidden";
    this.actionView.yAxisDiv.style.visibility = "hidden";
    var ret = SvgChartUtil.getPeriod(timeFrame, this.mainTechnical.data);
    var period = ret["period"];

    if (this.period != period) {
      this.changePeriod(period);
    } else {
      var startIndex = ret["startIndex"];
      var dataLength = ret["dataLength"];
      this.setDataRange(startIndex, dataLength);
    }

    if (this.chartConfig.showScroll) {
      this.scrollView.scrollActionStatus = null;
    }
  };

  SvgChart.prototype.changeTimeFrame_sw = function (timeFrame) {
    this.timeFrame = timeFrame;
    this.timeFrameUpdated = true;
    this.actionView.dataDiv.style.visibility = "hidden";
    this.actionView.xAxisDiv.style.visibility = "hidden";
    this.actionView.yAxisDiv.style.visibility = "hidden";

    var param = timeFrame;
    var now = new Date();
    var begin;
    if (param == "1W") {
      begin = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
    } else if (param == "1M") {
      begin = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
    } else if (param == "3M") {
      begin = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());
    } else if (param == "6M") {
      begin = new Date(now.getFullYear(), now.getMonth() - 6, now.getDate());
    } else if (param == "1Y") {
      begin = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
    } else if (param == "3Y") {
      begin = new Date(now.getFullYear() - 3, now.getMonth(), now.getDate());
    } else if (param == "5Y") {
      begin = new Date(now.getFullYear() - 5, now.getMonth(), now.getDate());
    } else if (param == "YTD") {
      begin = new Date(now.getFullYear(), 0, 1);
    }

    var format = "YYYY/MM/DD";
    begin = begin.format(format);
    var end = now.format(format);

    for (var i = 0; i < this.viewList[0].technicalList.length; i++) {
      var tech = this.viewList[0].technicalList[i];
      if (i == 0) {
        tech.setLoadType(
          SvgChartTechnical.DATA_LOAD_TYPE_URL,
          MST.getDataUrl(tech.code, begin, end)
        );
      } else {
        tech.setLoadType(
          SvgChartTechnical.DATA_LOAD_TYPE_URL,
          MST.getDataUrl_mdd(tech.code, this.period, {
            begin_at: begin,
            end_at: end,
          })
        );
      }
      tech.dataStatus = SvgChartTechnical.DATA_STATUS_INIT;
    }

    this.loadData();
  };

  SvgChart.prototype.onclick = function () {
    var controllerView = this.controllerView;

    if (this.chartConfig.controller.showIndicator) {
      controllerView.indicatorControllerView.hiddenItem();
    }
    if (this.chartConfig.controller.showBenchmark) {
      controllerView.benchmarkControllerView.hiddenItem();
    }
  };

  var SvgChartBackground = function (chart) {
    this.chart = chart;
    //	this.mapping = new SvgChartMapping();

    this.backgroundDiv = document.createElement("div");
    this.backgroundDiv.style.position = "absolute";
    this.backgroundDiv.style.width = "100%";
    this.backgroundDiv.style.height = "100%";
    this.backgroundDiv.style.zIndex = 1;

    chart.chartDiv.appendChild(this.backgroundDiv);
    //	this.panelDrawCanvas = SvgChartDrawUtil.createCanvas(this.backgroundDiv, chart.chartWidth, 100);
  };
  SvgChartBackground.prototype.panelDiv = null;
  SvgChartBackground.prototype.panelDrawCanvas = null;
  SvgChartBackground.prototype.drawAreaHeight = null;

  SvgChart.prototype.drawLastClose = function () {
    return this.period == "5m" || this.period == "1m";
    //	return this.period == "1m";
  };

  SvgChart.prototype.closeMenu = function () {
    var indictorView = this.controllerView.hiddenOtherItems("all");
  };

  SvgChart.prototype.setBenchmarkTitleFlag = function (flag) {
    this.addBenchmarkFundTitleFlag = flag;
  };

  MST.SvgChart = SvgChart;
})();
